import sObjetos from '@/aplicacao/_servicos/objetos'
import sUtilitarios from '@/aplicacao/_servicos/utilitarios'

const Usuario = (load) => ({
    id: load ? (load.id ? load.id : '') : '',
    nome: load ? (load.nome ? load.nome : '') : '',
    email: load ? (load.email ? load.email : '') : '',
    producao: load ? (load.producao ? true : false) : false,
    distribuidor: load ? (load.distribuidor ? true : false) : false,
    criadoEm: load ? (load.criadoEm ? load.criadoEm : '') : '',
})

const Preferencias = (load) => ({
    tema: load ? (load.tema ? load.tema : 'colorido') : 'colorido',
    receberEmailsFluxoEncartes: load ? (load.hasOwnProperty('receberEmailsFluxoEncartes') ? load.receberEmailsFluxoEncartes : true) : true,
    receberEmailsFluxoEncartesVirtuais: load ? (load.hasOwnProperty('receberEmailsFluxoEncartesVirtuais') ? load.receberEmailsFluxoEncartesVirtuais : true) : true,
    receberEmailsFluxoBox: load ? (load.hasOwnProperty('receberEmailsFluxoBox') ? load.receberEmailsFluxoBox : true) : true,
})

const Perfil = (load) => ({
    perfilOriginal: load ? (load.perfilOriginal ? load.perfilOriginal : null) : null,
    perfilMiniatura: load ? (load.perfilMiniatura ? load.perfilMiniatura : null) : null,
    capaOriginal: load ? (load.capaOriginal ? load.capaOriginal : null) : null,
    capaMiniatura: load ? (load.capaMiniatura ? load.capaMiniatura : null) : null,
    cargo: load ? (load.cargo ? load.cargo : null) : null,
    sobre: load ? (load.sobre ? load.sobre : null) : null,
    telefone1: load ? (load.telefone1 ? load.telefone1 : null) : null,
    telefone2: load ? (load.telefone2 ? load.telefone2 : null) : null,
    telefone3: load ? (load.telefone3 ? load.telefone3 : null) : null,
})

const Expiracao = (load) => ({
    expiracaoHabilitada: load ? (load.expiracaoHabilitada ? true : false) : false,
    senhaExpirada: load ? (load.senhaExpirada ? true : false) : false,
    prazoDeExpiracao: load ? (load.prazoDeExpiracao ? load.prazoDeExpiracao : 0) : 0,
    ultimaAlteracaoEm: load ? (load.ultimaAlteracaoEm ? load.ultimaAlteracaoEm : null) : null,
    vaiExpirarEm: load ? (load.vaiExpirarEm ? load.vaiExpirarEm : null) : null,
    diasParaExpirar: load ? (load.diasParaExpirar ? load.diasParaExpirar : 0) : 0,
    offsetMensagem: load ? (load.offsetMensagem ? load.offsetMensagem : 0) : 0,
})

const State = () => ({
    usuario: Usuario(),
    permissoes: [],
    preferencias: Preferencias(),
    perfil: Perfil(),
    expiracao: Expiracao(),
})

const mutations = {

    resetar(stateParam) { sObjetos.preencher(stateParam, State()) },

    setUsuario(state, payload) { state.usuario = payload },
    setPermissoes(state, payload) { state.permissoes = payload },
    setPreferencias(state, payload) { state.preferencias = payload },
    setPerfil(state, payload) { state.perfil = payload },
    setExpiracao(state, payload) { state.expiracao = payload },

    setTelefone1(state, payload) { state.perfil.telefone1 = payload },

}

const actions = {

    resetar({ commit }, payload) { commit('resetar', payload) },

    setUsuario({ commit }, payload) { commit('setUsuario', Usuario(payload)) },
    setPermissoes({ commit }, payload) { commit('setPermissoes', payload.map(p => p.role)) },
    setPreferencias({ commit }, payload) { commit('setPreferencias', Preferencias(payload)) },
    setPerfil({ commit }, payload) { commit('setPerfil', Perfil(payload)) },
    setExpiracao({ commit }, payload) { commit('setExpiracao', Expiracao(payload)) },

    atualizarTelefone({ commit }, payload) { commit('setTelefone1', payload) },

}

const getters = {

    token: () => localStorage.getItem('token'),

    temPermissao: (state) => (role) => state.permissoes.includes(role),

    primeiroNome: (state) => state.usuario.nome.split(' ')[0],

    bomDiaTardeNoite: (state, getters) => {

        const horaAtual = new Date().getHours()

        let horaPrefixo

        if (horaAtual >= 6 && horaAtual < 12) horaPrefixo = 'Bom dia'
        else if (horaAtual >= 12 && horaAtual < 18) horaPrefixo = 'Boa tarde'
        else horaPrefixo = 'Boa noite'

        return horaPrefixo

    },

    saudacao: (state, getters) => getters.bomDiaTardeNoite + ', ' + sUtilitarios.humanizar(getters.primeiroNome) + '!',

}

export default {
    state: State(),
    mutations,
    actions,
    getters,
}
